import type { TezamPlanCode } from "@/shared/types/onboard.types";

export type PublicSubscriptionPlan = {
    code: string;
    name: string;
    description?: string;
    audienceLabel?: string;
    badge?: string;
    featured?: boolean;
    amount?: number;
    yearlyAmount?: number;
    currency?: string;
    period?: string;
    maxProducts?: number | null;
    maxServices?: number | null;
    maxStaff?: number | null;
    maxLocations?: number | null;
    modules?: Record<string, boolean>;
    features?: string[];
    bullets?: string[];
    excluded?: string[];
    ctaLabel?: string;
    sortOrder?: number;
};

function resolveBackendBase(): string {
    if (process.env.TEZAM_ONBOARD_BACKEND_URL) {
        return process.env.TEZAM_ONBOARD_BACKEND_URL.replace(/\/$/, "");
    }
    if (process.env.NEXT_PUBLIC_TEZAM_API_BASE) {
        return process.env.NEXT_PUBLIC_TEZAM_API_BASE.replace(/\/$/, "");
    }
    // Browser / SSR fallback to PROD public API
    return "https://prod-api.tezam.by/api";
}

/** Server-side fetch of public tariff catalog (platform_subscription_plan). */
export async function fetchPublicSubscriptionPlans(): Promise<PublicSubscriptionPlan[]> {
    const base = resolveBackendBase();
    const url = `${base}/public/subscription/plans`;
    try {
        const res = await fetch(url, {
            next: { revalidate: 60 },
            headers: { Accept: "application/json" },
            signal: AbortSignal.timeout(2500),
        });
        if (!res.ok) {
            return [];
        }
        const data = (await res.json()) as PublicSubscriptionPlan[];
        return Array.isArray(data) ? data : [];
    } catch {
        return [];
    }
}

export function isCommercialPlanCode(code: string | undefined): code is TezamPlanCode {
    return code === "start" || code === "business" || code === "pro" || code === "holding";
}
